import  {ECommerceIntegrationType, IECommerceDanDomainIntegration, IECommerceIntegration, IECommerceIntegrations} from "@chaosinsight/postoffice-portalclient"

export default class ECommerceIntegrations {
	public danDomain: ECommerceDanDomainIntegration | null = null
	public shopify: ECommerceIntegration | null = null
	public wooCommerce: ECommerceIntegration | null = null

	public get hasDanDomain(): boolean {
		return this.danDomain !== null
	}
	public get hasShopify(): boolean {
		return this.shopify !== null
	}
	public get hasWooCommerce(): boolean {
		return this.wooCommerce !== null
	}

	public get firstIntegrationType(): ECommerceIntegrationType | null {
		if (this.hasDanDomain) return ECommerceIntegrationType.danDomain
		if (this.hasShopify) return ECommerceIntegrationType.shopify
		if (this.hasWooCommerce) return ECommerceIntegrationType.wooCommerce
		return null
	}

	public get hasAny(): boolean {
		return this.hasDanDomain || this.hasShopify || this.hasWooCommerce
	}

	constructor(danDomain: ECommerceDanDomainIntegration | null, shopify: ECommerceIntegration | null, wooCommerce: ECommerceIntegration | null) {
		this.danDomain = danDomain
		this.shopify = shopify
		this.wooCommerce = wooCommerce
	}

	public has(type: ECommerceIntegrationType): boolean {
		switch (type) {
			case ECommerceIntegrationType.danDomain:
				return this.danDomain !== null
			case ECommerceIntegrationType.shopify:
				return this.shopify !== null
			case ECommerceIntegrationType.wooCommerce:
				return this.wooCommerce !== null
		}
	}

	public clone(): ECommerceIntegrations {
		return new ECommerceIntegrations(
			this.danDomain?.clone() ?? null,
			this.shopify?.clone() ?? null,
			this.wooCommerce?.clone() ?? null
		)
	}

	public static fromApi(data: IECommerceIntegrations): ECommerceIntegrations {
		return new ECommerceIntegrations(
			data.DanDomain ? new ECommerceDanDomainIntegration(data.DanDomain.Link, data.DanDomain.SecretKey) : null,
			data.Shopify ? new ECommerceIntegration(data.Shopify.Link) : null,
			data.WooCommerce ? new ECommerceIntegration(data.WooCommerce.Link) : null
		)
	}
}

export class ECommerceIntegration {
	public link: string

	constructor(link: string) {
		this.link = link
	}

	public toApi(): IECommerceIntegration {
		return {
			Link: this.link
		}
	}

	public clone(): ECommerceIntegration {
		return new ECommerceIntegration(this.link)
	}
}

export class ECommerceDanDomainIntegration extends ECommerceIntegration{
	public secretKey: string

	constructor(link: string, secretKey: string) {
		super(link)
		this.secretKey = secretKey
	}

	public toApi(): IECommerceDanDomainIntegration {
		return {
			Link: this.link,
			SecretKey: this.secretKey
		}
	}

	public clone(): ECommerceDanDomainIntegration {
		return new ECommerceDanDomainIntegration(this.link, this.secretKey)
	}
}
